export default "__VITE_ASSET__Cqzg_k9J__";